import React from 'react';
import { MapPin, Phone, Mail } from 'lucide-react';
import { AnimatedSection } from '../components/AnimatedSection';
import { SectionHeading } from '../components/SectionHeading';
import { Link } from 'react-router-dom';
export function Contact() {
  return <div className="w-full pt-24 bg-offwhite min-h-screen" data-id="element-456">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 py-16" data-id="element-457">
        <AnimatedSection className="text-center mb-16" data-id="element-458">
          <SectionHeading title="Neem contact op" subtitle="Start uw waardebepaling" align="center" className="mx-auto" data-id="element-459" />
          <p className="text-charcoal/70 max-w-2xl mx-auto mt-6" data-id="element-460">
            Heeft u vragen over een bedrijfswaardering of wilt u direct een
            intake plannen? Vul het formulier in of neem direct contact met ons
            op.
          </p>
        </AnimatedSection>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 max-w-5xl mx-auto" data-id="element-461">
          {/* Contact Info */}
          <div className="lg:col-span-1 space-y-8" data-id="element-462">
            <AnimatedSection delay={0.1} className="bg-white p-8 rounded-2xl shadow-sm border border-warmgray/50" data-id="element-463">
              <div className="w-12 h-12 bg-offwhite rounded-full flex items-center justify-center text-accent mb-6" data-id="element-464">
                <MapPin size={24} data-id="element-465" />
              </div>
              <h3 className="text-lg font-medium text-charcoal mb-2" data-id="element-466">
                Bezoekadres
              </h3>
              <p className="text-charcoal/70 text-sm" data-id="element-467">
                Zuidas 123
                <br data-id="element-468" />
                1082 MM Amsterdam
              </p>
            </AnimatedSection>

            <AnimatedSection delay={0.2} className="bg-white p-8 rounded-2xl shadow-sm border border-warmgray/50" data-id="element-469">
              <div className="w-12 h-12 bg-offwhite rounded-full flex items-center justify-center text-accent mb-6" data-id="element-470">
                <Phone size={24} data-id="element-471" />
              </div>
              <h3 className="text-lg font-medium text-charcoal mb-2" data-id="element-472">
                Telefoon
              </h3>
              <p className="text-charcoal/70 text-sm" data-id="element-473">
                020 - 123 45 67
                <br data-id="element-474" />
                Ma-Vr: 09:00 - 17:30
              </p>
            </AnimatedSection>

            <AnimatedSection delay={0.3} className="bg-white p-8 rounded-2xl shadow-sm border border-warmgray/50" data-id="element-475">
              <div className="w-12 h-12 bg-offwhite rounded-full flex items-center justify-center text-accent mb-6" data-id="element-476">
                <Mail size={24} data-id="element-477" />
              </div>
              <h3 className="text-lg font-medium text-charcoal mb-2" data-id="element-478">E-mail</h3>
              <p className="text-charcoal/70 text-sm" data-id="element-479">
                info@waardebepaling.nl
                <br data-id="element-480" />
                Binnen 24 uur reactie
              </p>
            </AnimatedSection>
          </div>

          {/* Form */}
          <div className="lg:col-span-2" data-id="element-481">
            <AnimatedSection delay={0.2} className="bg-white p-10 rounded-3xl shadow-sm border border-warmgray/50" data-id="element-482">
              <h2 className="text-2xl font-light text-charcoal mb-8" data-id="element-483">
                Stuur ons een bericht
              </h2>
              <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-484">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-485">
                  <div data-id="element-486">
                    <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-487">
                      Naam
                    </label>
                    <input type="text" className="w-full px-4 py-3 rounded-xl border border-warmgray/50 focus:ring-2 focus:ring-accent focus:border-accent outline-none bg-offwhite" placeholder="Uw naam" data-id="element-488" />
                  </div>
                  <div data-id="element-489">
                    <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-490">
                      Bedrijfsnaam
                    </label>
                    <input type="text" className="w-full px-4 py-3 rounded-xl border border-warmgray/50 focus:ring-2 focus:ring-accent focus:border-accent outline-none bg-offwhite" placeholder="Uw bedrijf" data-id="element-491" />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-492">
                  <div data-id="element-493">
                    <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-494">
                      E-mailadres
                    </label>
                    <input type="email" className="w-full px-4 py-3 rounded-xl border border-warmgray/50 focus:ring-2 focus:ring-accent focus:border-accent outline-none bg-offwhite" placeholder="email@bedrijf.nl" data-id="element-495" />
                  </div>
                  <div data-id="element-496">
                    <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-497">
                      Telefoonnummer
                    </label>
                    <input type="tel" className="w-full px-4 py-3 rounded-xl border border-warmgray/50 focus:ring-2 focus:ring-accent focus:border-accent outline-none bg-offwhite" placeholder="06 12345678" data-id="element-498" />
                  </div>
                </div>

                <div data-id="element-499">
                  <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-500">
                    Bericht / Vraag
                  </label>
                  <textarea rows={5} className="w-full px-4 py-3 rounded-xl border border-warmgray/50 focus:ring-2 focus:ring-accent focus:border-accent outline-none bg-offwhite resize-none" placeholder="Hoe kunnen we u helpen?" data-id="element-501"></textarea>
                </div>

                <button type="submit" className="bg-accent hover:bg-accent-hover text-white px-8 py-4 rounded-xl text-base font-medium transition-all shadow-subtle w-full md:w-auto" data-id="element-502">
                  Verstuur bericht
                </button>
              </form>
            </AnimatedSection>
          </div>
        </div>

        {/* Additional Links Section */}
        <div className="max-w-5xl mx-auto mt-16 grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-503">
          <AnimatedSection delay={0.3} className="bg-charcoal text-white p-10 rounded-3xl text-center flex flex-col items-center justify-center" data-id="element-504">
            <h3 className="text-2xl font-light mb-4" data-id="element-505">
              Of start direct met een waardebepaling
            </h3>
            <p className="text-warmgray/80 mb-6" data-id="element-506">
              Ontdek wat uw bedrijf écht waard is met een professioneel rapport.
            </p>
            <Link to="/bedrijfswaardering" className="inline-block bg-accent hover:bg-accent-hover text-white px-6 py-3 rounded-full text-sm font-medium transition-all" data-id="element-507">
              Start waardebepaling
            </Link>
          </AnimatedSection>

          <AnimatedSection delay={0.4} className="bg-white p-10 rounded-3xl border border-warmgray/50 text-center flex flex-col items-center justify-center" data-id="element-508">
            <h3 className="text-2xl font-light text-charcoal mb-4" data-id="element-509">
              Meer weten?
            </h3>
            <p className="text-charcoal/70 mb-6" data-id="element-510">
              Lees eerst meer over bedrijfswaardering in onze uitgebreide
              kennisbank.
            </p>
            <Link to="/kennisbank" className="inline-block border border-charcoal/20 hover:bg-charcoal hover:text-white text-charcoal px-6 py-3 rounded-full text-sm font-medium transition-all" data-id="element-511">
              Naar kennisbank
            </Link>
          </AnimatedSection>
        </div>
      </div>
    </div>;
}